import ko from 'knockout';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

const s$AdGroup = window.globalLegacySchema.get('AdGroup');

export default class ViewModel {
  constructor({
    Name = '',
  } = {}) {
    this.fields = ['Name', 'Language'];
    koSchema.properties(this, s$AdGroup, this.fields, { Name });
    this.showKeywordPlanner = ko.observable(false);
  }
}
